'use strict';
module.exports = require('./Ripple.js');